import { printCurrentDocument } from '../../../../shared/documents';

const labels = { cv: 'CV ICC', skills_portfolio: 'Dossier de compétences ICC', premium: 'Fiche premium ICC' };

export default function DocumentPreviewToolbar({ type, onTypeChange, zoom, onZoomChange, page, totalPages, onPageChange, allowTypeChange = true }) {
  const handlePrint = async () => {
    try {
      await printCurrentDocument();
    } catch (error) {
      console.error('Impossible de lancer l’impression du document RH.', error);
    }
  };

  return <div className="document-preview-toolbar">{allowTypeChange && <label>Modèle<select value={type} onChange={(event) => onTypeChange(event.target.value)}>{Object.entries(labels).map(([value, label]) => <option value={value} key={value}>{label}</option>)}</select></label>}<div className="document-preview-toolbar__pager"><button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>Précédente</button><span>Page {page} / {totalPages}</span><button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>Suivante</button></div><label>Zoom<input type="range" min="35" max="110" step="5" value={zoom} onChange={(event) => onZoomChange(Number(event.target.value))}/><span>{zoom}%</span></label><button type="button" onClick={handlePrint}>Imprimer</button></div>;
}
